var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"landing-info"},_vm._l((_vm.sections),function(section){return _c('landing-info-item',{key:section.id,attrs:{"section":section}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }